import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const pathNames = {
    '': 'Начало',
    'products': 'Продукти',
    'product': 'Продукт',
    'about': 'За нас',
    'delivery': 'Доставка',
    'contact': 'Контакти',
    'faq': 'Въпроси',
    'cart': 'Количка',
    'checkout': 'Поръчка',
    'profile': 'Профил',
    'orders': 'Поръчки',
    'login': 'Вход',
    'register': 'Регистрация',
    'terms': 'Условия',
    'returns': 'Връщане и възстановяване',
    'privacy': 'Поверителност',
    'admin': 'Админ',
};

const Breadcrumbs = ({ customItems, productName }) => {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    // Don't show on homepage
    if (pathSegments.length === 0) return null;

    const breadcrumbItems = customItems || pathSegments.map((segment, index) => {
        const path = '/' + pathSegments.slice(0, index + 1).join('/');
        let name = pathNames[segment] || segment;
        
        // If this is the last segment and we have a product name, use it
        if (index === pathSegments.length - 1 && productName) {
            name = productName;
        }
        
        return { path, name };
    });

    return (
        <nav className="flex items-center gap-2 text-sm text-slate-500 mb-6 flex-wrap">
            <Link 
                to="/" 
                className="flex items-center gap-1 hover:text-amber-600 transition-colors"
            >
                <Home className="h-4 w-4" />
                <span className="hidden sm:inline">Начало</span>
            </Link>
            
            {breadcrumbItems.map((item, index) => (
                <React.Fragment key={item.path}>
                    <ChevronRight className="h-4 w-4 text-slate-300" />
                    {index === breadcrumbItems.length - 1 ? (
                        <span className="text-slate-700 font-medium truncate max-w-[200px]">
                            {item.name}
                        </span>
                    ) : (
                        <Link 
                            to={item.path}
                            className="hover:text-amber-600 transition-colors"
                        >
                            {item.name}
                        </Link>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
};

export default Breadcrumbs;
